const ErrUnauthorised = new Error("");
const ErrUnauthorisedStatus = new Error(
  "You do not have permission to change the status of this site. Please contact your College/School admin for support.",
);
const ErrUnauthorisedCreateMergeSites = new Error(
  "You do not have permission to merge these sites as you don't have the correct permissions or the site has already been claimed. Please contact your College/School admin for support.",
);
const ErrUnauthorisedRoles = new Error(
  "You do not have permission to change user enrolment in this course. Please contact your College/School admin for support.",
);
const ErrUnauthorisedCreateSandpits = new Error(
  "You do not have permission to create sandpits.",
);
const ErrUnauthorisedDates = new Error(
  "You do not have permission to change dates. Please contact your College/School admin for support.",
);
const ErrUnauthorisedAcademicOrg = new Error(
  "You do not have permission to change academic org. Please contact your College/School admin for support.",
);
const ErrUnauthorisedAcademicTerm = new Error(
  "You do not have permission to change academic term. Please contact your College/School admin for support.",
);

const isPermissionError = (err: Error) => {
  return err.message.includes("permission_denied");
};

export {
  ErrUnauthorised,
  ErrUnauthorisedStatus,
  ErrUnauthorisedRoles,
  ErrUnauthorisedDates,
  ErrUnauthorisedAcademicOrg,
  ErrUnauthorisedAcademicTerm,
  ErrUnauthorisedCreateMergeSites,
  ErrUnauthorisedCreateSandpits,
  isPermissionError,
};
